import { render, staticRenderFns } from "./LocaleSelector.vue?vue&type=template&id=b21dde6c&lang=pug"
import script from "./LocaleSelector.vue?vue&type=script&lang=ts"
export * from "./LocaleSelector.vue?vue&type=script&lang=ts"
import style0 from "./LocaleSelector.vue?vue&type=style&index=0&id=b21dde6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports